// extracted by mini-css-extract-plugin
export default {"root":"xXMVw__root time-label"};